import CityScreen from './CityScreen';
import { useCityContext } from './useCityContext';

export default function CityLand() {
  const { loading, error, context, cityTypeLabel } = useCityContext();
  const blocked = context?.access?.canUseLand === false;

  if (loading) return <div className="min-h-screen bg-[#04060d] text-cyan-200 flex items-center justify-center">Cargando terrenos...</div>;
  if (error) return <div className="min-h-screen bg-[#04060d] text-rose-200 flex items-center justify-center">{error}</div>;

  return (
    <CityScreen
      context={context}
      cityTypeLabel={cityTypeLabel}
      title={`Terrenos - ${context.city?.name || 'Ciudad'}`}
      subtitle="Infraestructura y expansión"
    >
      {blocked && (
        <section className="rounded-xl border border-amber-500/30 bg-amber-500/10 p-4">
          <p className="text-amber-200 text-sm">Acceso restringido: piloto neutral en ciudad de clan no puede comprar Terrenos.</p>
        </section>
      )}
      <section className="rounded-xl border border-cyan-500/30 bg-[#08101f] p-5">
        <p className="text-slate-300 text-sm">Próxima fase: compra de parcelas, construcción de edificios y producción colaborativa de clan/subclan.</p>
      </section>
    </CityScreen>
  );
}
